import { useMemo } from "react";
import { movies, heroSlides } from "@/mocks/movies";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import HeroCarousel from "./components/HeroCarousel";
import SearchBanner from "./components/SearchBanner";
import CategoryQuick from "./components/CategoryQuick";
import MovieSection from "./components/MovieSection";

export default function Home() {
  useDocumentTitle(
    "鸭王在线观看_最新电影在线免费播放平台",
    "鸭王在线观看网站提供最新电影资源和在线播放服务，涵盖多种类型电影，方便用户轻松在线观看视频。鸭王在线观看让你随时享受高清影视体验。"
  );

  const latest = useMemo(
    () => [...movies].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt)).slice(0, 12),
    []
  );
  const hot = useMemo(
    () => [...movies].sort((a, b) => b.views - a.views).slice(0, 12),
    []
  );

  return (
    <>
      <HeroCarousel slides={heroSlides} />
      <SearchBanner />
      <CategoryQuick />
      <MovieSection
        title="最新电影"
        subtitle="按更新时间为你呈现最新上线的影片"
        movies={latest}
        moreHref="/search"
      />
      <MovieSection
        title="热门推荐"
        subtitle="根据站内热度排行，大家都在看的影片"
        movies={hot}
        moreHref="/search"
        rank
      />
    </>
  );
}